import { connect } from "react-redux";
import RequestComponent from "./RequestComponent";

function ApproveRequest(props) {
  return (
    <>
      <RequestComponent isApprover={true} />
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ApproveRequest);
